import {
    Directive,
    ElementRef,
    Input,
    OnInit,
    OnDestroy,
    OnChanges,
    SimpleChanges
} from '@angular/core'

declare let $

@Directive({
    selector: '[colTooltip]'
})
export class TooltipDirective implements OnInit, OnChanges, OnDestroy {
    // tslint:disable-next-line:no-input-rename
    @Input('colTooltip') conteudo: string
    @Input() appendToBody: boolean
    @Input() placement: string

    private iniciado: boolean
    private aberto: boolean
    private reiniciarAoFechar: boolean

    constructor(private element: ElementRef) {
        this.placement = 'auto'
        this.appendToBody = false
        this.aberto = false
        this.reiniciarAoFechar = false
    }

    ngOnInit() {
        this.iniciar()
        this.receberEventos()
    }

    ngOnChanges(changes: SimpleChanges) {
        this.aplicarAlteracoes(changes)
    }

    ngOnDestroy() {
        this.destruir()
    }

    private iniciar() {
        $(this.element.nativeElement).tooltip({
            html: true,
            trigger: 'hover',
            placement: () => this.placement,
            title: () => this.conteudo,
            container: this.appendToBody ? 'body' : false,
            delay: { show: 300 }
        })

        this.iniciado = true
    }

    private receberEventos() {
        $(this.element.nativeElement)
            .on('shown.bs.tooltip', () => {
                this.aberto = true
            })
            .on('hidden.bs.tooltip', () => {
                this.aberto = false

                if (this.reiniciarAoFechar) {
                    this.reiniciar()
                    this.reiniciarAoFechar = false
                }
            })
    }

    private reiniciar() {
        this.destruir()
        this.iniciar()
    }

    private resetarConteudo() {
        if (this.aberto) {
            $(this.element.nativeElement).tooltip('show')
        }
    }

    private tentarReiniciar() {
        if (this.aberto) {
            this.reiniciarAoFechar = true
        } else {
            this.reiniciar()
        }
    }

    private destruir() {
        $(this.element.nativeElement)
            .tooltip('destroy')
            .removeData('bs.tooltip')
            .off('mouseenter.tooltip')
            .off('mouseleave.tooltip')
            .off('focusin.tooltip')
            .off('focusout.tooltip')
    }

    private aplicarAlteracoes(changes: SimpleChanges) {
        if (this.iniciado) {
            if ('appendToBody' in changes) {
                this.tentarReiniciar()
            }

            this.resetarConteudo()
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/tooltip.directive.ts